"use strict";

require("core-js/modules/es6.function.bind");

require("core-js/modules/es6.object.define-property");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _get = _interopRequireDefault(require("lodash/get"));

var _postMessageHelper = _interopRequireDefault(require("@eig-builder/core-utils/helpers/post-message-helper"));

var _currentLanguageHelper = _interopRequireDefault(require("@eig-builder/core-utils/helpers/current-language-helper"));

var _scriptHelper = require("@eig-builder/core-utils/helpers/script-helper");

var _provider = _interopRequireDefault(require("./provider"));

var _localizeFormatter = _interopRequireDefault(require("./../helpers/localize-formatter"));

var _subscribeHelper = require("../helpers/subscribe-helper"); // import { getUrl, siteNames } from '@eig-builder/core-utils/helpers/url-helper'


var translationManagementApi = 'https://tr-management-api.latest.builderservices.io';

var Localization = function Localization(_ref) {
  var children = _ref.children,
      retrieving = _ref.retrieving,
      translationKeys = _ref.translationKeys,
      localize = _ref.localize,
      _localizeDebug = _ref._localizeDebug;

  var _useState = (0, _react.useState)(null),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      postMessageHandler = _useState2[0],
      setPostMessageHandler = _useState2[1];

  (0, _react.useEffect)(function () {
    if (_localizeDebug) {
      loadInlineEditor();
    }
  }); // Unsubscribe post message handler on unmount

  (0, _react.useEffect)(function () {
    return function () {
      return (0, _subscribeHelper.unSubscribeToTranslationChange)(postMessageHandler, setPostMessageHandler);
    };
  }, []);
  /**
   * subscribe To Tanslation Change to the post messages, that are send from the iframe inside the inline editor modal
   * the new translation will be showed after it was received
   *
   *
   * @memberOf TextComponent
   */

  var subscribeToTanslationChange = function subscribeToTanslationChange() {
    // Set value in translationKeys for posible redraw of a screen
    var newPostMessageHelper = new _postMessageHelper["default"]();
    newPostMessageHelper.bind('translation_message', function (data) {
      translationKeys[data.key] = data.text;
    });
    setPostMessageHandler(newPostMessageHelper);
  };
  /**
   * Load the inline editor from the translation backend
   *
   */


  var loadInlineEditor = function loadInlineEditor() {
    var url = "".concat(translationManagementApi, "/v1.0/inlineeditor/script.js");
    (0, _scriptHelper.IncludeJavaScript)(url, 'inline-localizations-editor', function () {
      var language = (0, _currentLanguageHelper["default"])();
      window.localizationPopup.setLanguageCode(language);
      window.localizationPopup.setGroup('Javascript');
      window.localizationPopup.setProduct('controlpanel');
      subscribeToTanslationChange();
    });
  };

  var localizeFunc = function localizeFunc(key, values) {
    values = values || [];
    var messages = translationKeys;
    var message = (0, _get["default"])(messages, key, null);
    return localize(message, key, values);
  };

  return /*#__PURE__*/_react["default"].createElement(_provider["default"], {
    _localizeDebug: _localizeDebug,
    localize: localizeFunc,
    children: children,
    retrieving: retrieving
  });
};

Localization.propTypes = {
  children: _propTypes["default"].element,
  retrieving: _propTypes["default"].bool,
  translationKeys: _propTypes["default"].object,
  localize: _propTypes["default"].func,
  _localizeDebug: _propTypes["default"].bool
};
Localization.defaultProps = {
  localize: _localizeFormatter["default"],
  _localizeDebug: false
};
var _default = Localization;
exports["default"] = _default;